<template>
    <div>
        <modal :show="show">
            <div class="modal-header">
                <h5 class="modal-title">Attachment</h5>
                <a href="javascript:void(0)" v-on:click="close()" class="close">
                    <em class="icon ni ni-cross"></em>
                </a>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-md-12">
                        <uploadimageview  v-bind:path="path" />

                    </div>
                </div>
            </div>
            <div class="modal-footer bg-light">
                <button type="button" class="btn btn-danger btn-round" v-on:click="close()">Cancel</button>
            </div>
        </modal>

    </div>
</template>
<script>

    export default {
        props: ['path', 'show'],
        data: function () {
            return {
                loading: false
            }
        },
        methods: {
            close: function () {
                this.$emit('close');
            },

        },

        mounted: function () {

        },

    }
</script>